export default "__VITE_ASSET__XsIl$eMx__"